const LCA = {
	banner: [
	{
		tips:'什么是LCA？',
		title:'LCA',
		content:'LCA指生命周期评价（Life Cycle Assessment），是对一个产品系统的生命周期中输入、输出及其潜在环境影响的汇编和评价。',
		img:require('@/assets/img/index/LCA_2x.png'),
		url: require('@/assets/img/index/banner01.png')
	}],
	seach:'搜索已公告的LCA'
}

export default LCA